export default __webpack_public_path__ + "static/media/ic_contest.c94803a5.svg";